import { atomFamily } from "jotai/utils";

import { AccidentType } from "types/DigitalJourneySession";

import { createDerivedSessionAtom } from "./utils/createDerivedSessionAtom";
import { createPersistedAtom } from "./utils/createPersistedAtom";

export const sessionTypeOfClaimAtom = atomFamily((sessionId: string) =>
  createPersistedAtom(`typeOfClaim-${sessionId}`, null as AccidentType | null)
);
export const typeOfClaimAtom = createDerivedSessionAtom<AccidentType | null>(sessionTypeOfClaimAtom);
